import copy from "clipboard-copy";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

export const LinkPushCommunityComponent = ({ communityLink, handleChange }) => {
  const { t } = useTranslation("dashboard");
  return (
    <div className="input-with-copy">
      <img
        alt={t("linkPushCommunity.altLink")}
        src="/img/new-icons/link.svg"
        className="mobile-hidden"
      />
      <input
        placeholder={t("linkPushCommunity.pasteLinkPlaceholder")}
        name="communityLink"
        onChange={handleChange}
        value={communityLink}
        type="text"
        className="text-input"
      />
      <div className="force-mobile-hidden">
        <button
          data-button-type="secondary"
          data-icon
          data-icon-only
          className="mobile-hidden"
          onClick={async (e) => {
            e.preventDefault();
            await copy(communityLink);
          }}
        >
          <img alt={t("linkPushCommunity.altCopy")} src="/img/new-icons/copy.svg" />
        </button>
      </div>
    </div>
  );
};

LinkPushCommunityComponent.propTypes = {
  communityLink: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};
